
// @ts-nocheck

import { Component, Prop, Vue, Emit } from 'vue-facing-decorator';
import ToggleButton from './ToggleButton.vue';
import { onMounted } from 'vue';

@Component({
  components: {
    ToggleButton,
  },
})

export default class ConsentItem extends Vue {

    value = true;

    @Prop( { default:"" }) label!: string;
    @Prop( { default:true }) consent!: boolean;
    
    mounted() : void {
      this.value = this.consent;
    }

    setConsent( v ) {
      this.value = v;
      console.log( "SensitiveDataItem:setConsent() : " + this.value );
    }
    
    @Emit('modelChangeEvent')
    changeConsent( e ) {
      this.value = ! this.value;
      console.log( "SensitiveDataItem:changeConsent() : " + this.value + " " + e );
      return this.value;
    }
}

